import { render } from "./foto-18.vue?vue&type=template&id=2a795359&scoped=true"
import script from "./foto-18.vue?vue&type=script&lang=js"
export * from "./foto-18.vue?vue&type=script&lang=js"

import "./foto-18.vue?vue&type=style&index=0&id=2a795359&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a795359"]])

export default __exports__